<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path d="M14 6V0h-2v8h8V6zM0 12v2h6v6h2v-8H6z"/><!-- Created by Stepan Voevodin from the Noun Project --></svg>
